// extracted by mini-css-extract-plugin
module.exports = {"singlePageMap":"styles_singlePageMap__euZQ9"};